const DEFAULT_INSTALLATION_NAME = 'OverChat';

export const replaceLegacyBrand = message => {
  if (typeof message !== 'string') return message;

  const installationName =
    window.globalConfig?.INSTALLATION_NAME ||
    window.chatwootConfig?.installationName ||
    DEFAULT_INSTALLATION_NAME;

  return message.replace(/Chatwoot/g, installationName);
};
